import { format, addSeconds } from 'date-fns'

export const formatBlogDate = (date) => format(date, 'PPP')
export const addSecondsToDate = (date = new Date(), seconds) => addSeconds(date, seconds)
export default {}
